import { isDevelopmentMode, sendRequest } from "../base";

export const getAllProducts = () => {
  return sendRequest(
    isDevelopmentMode() ? "/shop/products" : "/content/current_report/"
  );
};
